<template>
  <v-container id="info__content">
    <h1></h1>
    <nav-back-component/>

    <h1>
      {{$t('dataProtectionView.title')}}
    </h1>

    <h2>
      {{$t('dataProtectionView.general.title')}}
    </h2>

    <div>
      <p>
        {{$t('dataProtectionView.general.text1')}}
      </p>
      <br />
      <p>
        {{$t('dataProtectionView.general.text2')}}
      </p>
      <br />
      <p>
        {{$t('dataProtectionView.general.nutrigap')}}
      </p>
    </div>

    <h2>
      {{$t('dataProtectionView.responsible.title')}}
    </h2>

    <div>
      <ol>
        <li>
            {{$t('dataProtectionView.responsible.ol1')}}
          <br />
          <br />
          <span>
            {{$t('dataProtectionView.responsible.fibl')}}
          </span>
          <br />
          <p>Ackerstrasse 113 / Postfach 219</p>
          <p>CH-5070 Frick</p>
          <p>{{$t('dataProtectionView.responsible.phone')}} +41 62 8657-272</p>
          <p>info.suisse(at)fibl.org</p>
        </li>
        <br />

        <li>
          {{$t('dataProtectionView.responsible.ol1_text')}}
          <p>dataprotection(at)fibl.org</p>
        </li>
      </ol>
    </div>


    <h2>{{$t('dataProtectionView.rights.title')}}</h2>
    <div>
      <ol>
        <li>
          {{$t('dataProtectionView.rights.ol1')}}
          <ul>
            <li>{{$t('dataProtectionView.rights.ul1')}}</li>
            <li>{{$t('dataProtectionView.rights.ul2')}}</li>
            <li>{{$t('dataProtectionView.rights.ul3')}}</li>
            <li>{{$t('dataProtectionView.rights.ul4')}}</li>
            <li>{{$t('dataProtectionView.rights.ul5')}}</li>
            <li>{{$t('dataProtectionView.rights.ul6')}}</li>
            <li>{{$t('dataProtectionView.rights.ul7')}}</li>
          </ul>
        </li>
        <br />
        <p>{{$t('dataProtectionView.rights.ul8')}} </p>
        <br />
        <li>
          {{$t('dataProtectionView.rights.ol2')}}
        </li>
      </ol>
    </div>


    <h2>{{$t('dataProtectionView.personalData.title')}}</h2>
    <div>
      <ol>
        <li>
          {{$t('dataProtectionView.personalData.ol1')}}
          <ul>
            <li>{{$t('dataProtectionView.personalData.ul1')}}</li>
            <li>{{$t('dataProtectionView.personalData.ul2')}}</li>
            <li>{{$t('dataProtectionView.personalData.ul3')}}</li>
            <li>{{$t('dataProtectionView.personalData.ul4')}}</li>
            <li>{{$t('dataProtectionView.personalData.ul5')}}</li>
            <li>{{$t('dataProtectionView.personalData.ul6')}}</li>
            <li>{{$t('dataProtectionView.personalData.ul7')}}</li>
            <li>{{$t('dataProtectionView.personalData.ul8')}}</li>
            <li>{{$t('dataProtectionView.personalData.ul9')}} </li>
            <li>{{$t('dataProtectionView.personalData.ul10')}}</li>
          </ul>
        </li>
        <li>
          {{$t('dataProtectionView.personalData.ol2')}}
        </li>
      </ol>
    </div>


    <h2>{{$t('dataProtectionView.profile.title')}}</h2>
    <div>
      <ol>
        <li>{{$t('dataProtectionView.profile.ol1')}}</li>
        <li><span v-html="linkifiedI18n('dataProtectionView.profile.ol2')"/></li>
        <li>{{$t('dataProtectionView.profile.ol3')}}</li>
        <li>{{$t('dataProtectionView.profile.ol4')}}</li>
      </ol>
    </div>


    <h2>{{$t('dataProtectionView.cookies.title')}}</h2>
    <div>
      <ol>
        <li>
          {{$t('dataProtectionView.cookies.ol1')}} 
        </li>
        <li>
          {{$t('dataProtectionView.cookies.ol2')}}
          <ul>
            <li>{{$t('dataProtectionView.cookies.ul1')}}</li>
            <li>{{$t('dataProtectionView.cookies.ul2')}}</li>
            <li>{{$t('dataProtectionView.cookies.ul3')}}</li>
          </ul>
          <ol type="a">
            <li>
              {{$t('dataProtectionView.cookies.al1')}}
            </li>
            <li>
              {{$t('dataProtectionView.cookies.al2')}}
            </li>
            <li>
              {{$t('dataProtectionView.cookies.al3_1')}}(<a href="https://addons.mozilla.org/de/firefox/addon/clear-flash-cookies/">https://addons.mozilla.org/de/firefox/addon/clear-flash-cookies/</a>) 
              {{$t('dataProtectionView.cookies.al3_2')}}
            </li>
          </ol>
        </li>
        <li>
         {{$t('dataProtectionView.cookies.ol3')}}
          <p>
            {{$t('dataProtectionView.cookies.ol3_links')}}
          </p>
          <ul>
            <li>Internet Explorer: <a href="https://windows.microsoft.com/de-DE/windows-vista/Block-or-allow-cookies">https://windows.microsoft.com/de-DE/windows-vista/Block-or-allow-cookies</a></li>
            <li>Firefox: <a href="https://support.mozilla.org/de/kb/cookies-erlauben-und-ablehne">https://support.mozilla.org/de/kb/cookies-erlauben-und-ablehnen</a></li>
            <li>Chrome: <a href="https://support.google.com/chrome/bin/answer.py?hl=de&amp;hlrm=en&amp;answer=95647">https://support.google.com/chrome/bin/answer.py?hl=de&amp;hlrm=en&amp;answer=95647</a></li>
            <li>Safari: <a href="https://support.apple.com/de-de/guide/safari/manage-cookies-and-website-data-sfri11471/mac">https://support.apple.com/de-de/guide/safari/manage-cookies-and-website-data-sfri11471/mac</a></li>
            <li>Opera: <a href="https://help.opera.com/de/latest/web-preferences/#cookies">https://help.opera.com/de/latest/web-preferences/#cookies</a></li>
          </ul>
          <p>
            {{$t('dataProtectionView.cookies.ol3_text')}}
          </p>
        </li>
      </ol>
    </div>
  

    <h2>{{$t('dataProtectionView.webfonts.title')}}</h2>
    <div>
      <ol>
        <li>{{$t('dataProtectionView.webfonts.ol1')}}</li>
        <li>{{$t('dataProtectionView.webfonts.ol2')}}</li>
        <li><span v-html="linkifiedI18n('dataProtectionView.webfonts.ol3')"/></li>
        <li><span v-html="linkifiedI18n('dataProtectionView.webfonts.ol4')"/></li>
      </ol>
    </div>


    <h2>{{$t('dataProtectionView.further.title')}}</h2>
    <div>
      <ol>
        <li>
          {{$t('dataProtectionView.further.ol1')}}
        </li>
        <li>
          {{$t('dataProtectionView.further.ol2')}}
        </li>
      </ol>
    </div>


    <h2>{{$t('dataProtectionView.requests.title')}}</h2>
    <div>
      <ol>
        <li>
          {{$t('dataProtectionView.requests.ol1')}}
        </li>
        <li>
          {{$t('dataProtectionView.requests.ol2')}}
        </li>
      </ol>
    </div>


    <h2>{{$t('dataProtectionView.revocation.title')}}</h2>
    <div>
      <ol>
        <li>
          {{$t('dataProtectionView.revocation.ol1')}} 
        </li>
        <li>
          {{$t('dataProtectionView.revocation.ol2')}}
        </li>
        <li>
          {{$t('dataProtectionView.revocation.ol3')}}
        </li>
      </ol>
    </div>

  </v-container>
</template>

<script>
import NavBackComponent from '../components/NavBackComponent.vue'
import {linkify} from '@/main.js'

export default {
  components: { NavBackComponent },
  methods: {
    linkifiedI18n(val) {
      return linkify(this.$i18n.t(val));
    }
  }
}
</script>

<style>

</style>
NavBackComponent